export default __webpack_public_path__ + "static/media/netbank.28d1afef.svg";